<template>
	<div class="search">
		<div class="onePage" v-show="activePage === '1'">
			<div class="search-input-block">
				<div class="search-logo"><img src="~@/assets/img/search/sc-logo-2.png" alt="" /></div>
				<div class="search-input">
					<el-input placeholder="请输入关键词" v-model="keyWords2" class="input-with-select" @keyup.enter.native="toTwoPage">
						<el-select v-model="query.keyWordsParserType" slot="prepend" placeholder="">
							<el-option label="精准搜索" value="0"></el-option>
							<el-option label="模糊搜索" value="1"></el-option>
						</el-select>
						<el-button slot="append" class="seach-btn" @click.stop="toTwoPage">
							<!-- <img src="~@/assets/img/search/seach-1.png" alt="" /> -->
							<i class="iconfont iconseach seach-icon" style="font-size: 18px;"></i>
							搜索
						</el-button>
					</el-input>
				</div>
				<!--<div class="taglist-block">-->
				<!--<el-row class="new-list">-->
				<!--<el-col :span="4" v-for="item in tags" :key="item.tagId" class="li-col">-->
				<!--<a href="javascript:;" class="hovertext" @click.stop="selectedTag(item)">{{ item.name }}</a>-->
				<!--</el-col>-->
				<!--</el-row>-->
				<!--</div>-->
			</div>
		</div>
		<div class="twoPage" v-show="activePage === '2'">
			<div class="twopage-top">
				<el-row class="search-top">
					<el-col :span="4"><img src="~@/assets/img/search/sc-logo-1.png" alt="" /></el-col>
					<el-col :span="20">
						<div class="search-input">
							<el-input placeholder="请输入关键词" v-model="keyWords2" class="input-with-select" @keyup.enter.native="searchBtn">
								<el-select v-model="query.keyWordsParserType" slot="prepend" placeholder="">
									<el-option label="精准搜索" value="0"></el-option>
									<el-option label="模糊搜索" value="1"></el-option>
								</el-select>
								<el-button slot="append" class="seach-btn" @click.stop="searchBtn">
									<!-- <img src="~@/assets/img/search/seach-1.png" alt="" /> -->
									<i class="iconfont iconseach seach-icon" style="font-size: 18px;"></i>
									搜索
								</el-button>
							</el-input>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="twopage-mid">
				<el-row class="row-bottom padL">
					<el-col :span="14"><time-of-public @changeTime="changeTime" :selDays="query.days"></time-of-public></el-col>
					<el-col :span="5" class="textR">
						<filter-status :defaultValue="query.sort" :list="paixus" :themName="'信息排序'" @changeVal="changepaixu"></filter-status>
					</el-col>
					<el-col :span="5" class="textR"><el-button type="primary" class="thmeBackColor borderColor btnclass" size="mini" @click="initPage">查询</el-button></el-col>
				</el-row>
				<el-row class="row-bottom padL">
					<el-col :span="14">
						<filter-status :defaultValue="query.keyWordsType" :list="pipeiTypes" :themName="'匹配方式'" @changeVal="changepipeiTypes"></filter-status>
					</el-col>

					<el-col :span="5"><filter-status :defaultValue="query.property" :list="shuxings" :themName="'信息属性'" @changeVal="changeshuxing"></filter-status></el-col>
					<!--<el-col :span="5">-->
					<!--<span class="thmeName">地域切换:</span>-->
					<!--<el-cascader-->
					<!--ref="cascaderCity"-->
					<!--size="mini"-->
					<!--clearable-->
					<!--popper-class="city-cascader"-->
					<!--:options="cityList"-->
					<!--v-model="areaIds"-->
					<!--:props="defaultProps"-->
					<!--@change="handleChangeCity"-->
					<!--&gt;</el-cascader>-->
					<!--</el-col>-->
				</el-row>
				<el-row class="padL">
					<el-col :span="19"><meiti-type2 :defaultValue="meitiCheckList" :themName="'媒体类型'" @changeMeiti="changeMeitiType"></meiti-type2></el-col>
					<!--<el-col :span="5" style="line-height: 40px;">-->
					<!--<span class="thmeName">行业标签:</span>-->
					<!--<el-select v-model="tagValue" clearable placeholder="请选择行业标签" size="mini" popper-class="city-cascader">-->
					<!--<el-option v-for="item in tags" :key="tags.tagId" :label="item.name" :value="item.tagId"></el-option>-->
					<!--</el-select>-->
					<!--</el-col>-->
				</el-row>
			</div>
			<div class="twopage-bot">
				<el-row class="actionRow">
					<el-col :span="12" class="textL pageCountCol">
						<span>搜索结果</span>
						<span>共</span>
						<span class="red-font">{{ pageData.totalRows }}</span>
						<span>条</span>
					</el-col>
					<el-col :span="12" class="textR">
						<div v-show="pageData.totalRows > 0">
							<span class="dire dingbuleft hoverborder curpointer" @click="prePage"></span>
							<span class="direshuzi">{{ pageData.pageNo }}/{{ pageData.totalPages }}</span>
							<span class="dire dingburight hoverborder curpointer" @click="nextPage"></span>
						</div>
					</el-col>
				</el-row>
				<div class="line mt"></div>
				<el-row v-loading="loading" element-loading-spinner="el-icon-loading">
					<ul class="listul" v-if="pageData.totalRows != 0">
						<li class="lis" v-for="item in pageData.result" :key="item.id" :class="{ isRead: item.isRead }">
							<el-row class="lisrow" :class="{ active: item.ischeckd }">
								<el-col class="contentCol">
									<el-row>
										<el-col :span="24">
											<el-col :span="20" class="title textOverOneLine titleClass ">
												<a :href="item.url" v-html="item.title" class="hovertext" target="_blank">{{ item.title }}</a>
											</el-col>
											<!--<el-col :span="4" class="textL"><span class="yiduspan" v-show="item.isRead">已读</span></el-col>-->
										</el-col>
									</el-row>
									<el-row class="textOverTwoLine zhaoyaoClass zhaoyaoCol" v-html="item.content"></el-row>
									<el-row class="newInfos zhaoyaoClass" type="flex" justify="space-between">
										<el-col :span="16" class="textL">
											<el-row>
												<el-col :span="12">
													<!-- <img src="~@/assets/img/monitoring/list/fbsjicon.png" alt="" /> -->
													<i class="iconfont icontime list-time-icon"></i>
													发表时间: {{ $moment(item.pageTime).format('YYYY-MM-DD HH:mm') }}
												</el-col>
												<el-col :span="12">
													<!-- <img src="~@/assets/img/monitoring/list/laiyuan.png" alt="" /> -->
													<i class="iconfont iconlaiyuan list-time-icon" style="font-size: 22px;"></i>
													来源:{{ item.websiteName }}
												</el-col>
											</el-row>
										</el-col>
										<el-col :span="8" class="textR fuzhiline">
											<span class="iconimg fzyq  curpointer">
												<i class="iconfont iconfuzhiyuqing hovertext li-action-icon"></i>
												<div class="fuzhi borderColor">
													<div class="fuzhili hovertext curpointer" @click.stop="copy(item, 1)">复制舆情</div>
													<div class="fuzhili hovertext curpointert" @click.stop="copy(item, 2)">复制链接</div>
													<div class="arrow borderBottom"></div>
												</div>
											</span>
											<span class="iconimg  curpointer" @click.stop="singleEarly(item)">
												<!-- yjyq -->
												<i class="iconfont iconjiaruyujing hovertext li-action-icon"></i>
												<div class="tooltip">加入预警</div>
											</span>
											<span class="iconimg  curpointer" @click.stop="singlepublicReport(item)">
												<i class="iconfont iconyuqingshangbao hovertext li-action-icon"></i>
												<div class="tooltip">舆情上报</div>
											</span>
											<!--<span class="iconimg byd curpointer" @click.stop="biaoYiDu(item)">-->
											<!--<div class="tooltip">标为已读</div>-->
											<!--</span>-->
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</li>
					</ul>
					<div class="nodata" v-if="pageData.totalRows == 0">
						<div class="nodataImg">
							<div class="textC ">
								<i class="iconfont iconwushuju wushuju-icon"></i>
								<!-- <img src="~@/assets/img/earlyWarning/wsj_07.png" alt="" /> -->
							</div>
							<div class="textC font14 nodataText">暂无数据！</div>
						</div>
					</div>
				</el-row>

				<div class="line mb" v-if="pageData.totalRows > 0"></div>
				<el-row class="listFooter" v-if="pageData.totalRows > 0">
					<el-col :span="8" class="pageCountCol">
						<span>共</span>
						<span class="red-font">{{ pageData.totalRows }}</span>
						<span>条</span>
					</el-col>
					<el-col :span="16" class="textR flexcol">
						<el-pagination
							@current-change="handleCurrentChange"
							:page-size="pageData.pageSize"
							:page-count="pageData.totalPages"
							background
							:current-page="pageData.pageNo"
							layout="prev, pager, next,jumper"
							:total="pageData.totalRows"
							:pager-count="5"
						></el-pagination>
						<el-button class="go-btn">GO</el-button>
					</el-col>
				</el-row>
			</div>
		</div>
		<confirm-prop ref="confirmProp" :tips="tips" @sucess="confirmSucess"></confirm-prop>
		<confirm-warning-prop ref="confirmWarningProp" :tips="tips" @sucess="confirmSucess"></confirm-warning-prop>
		<success-prop :tips="tips" ref="successProp"></success-prop>
		<closed-prop :tips="tips" ref="closedProp"></closed-prop>
		<tool-tip-prop :tips="tips" ref="toolTipProp"></tool-tip-prop>
		<closed-prop2 ref="closedProp2"></closed-prop2>
		<confirm-prop2 ref="confirmProp2" @sucess="confirmSucess"></confirm-prop2>
		<report-loading ref="reportLoading"></report-loading>
		<loading-prop ref="loadingProp"></loading-prop>
		<add-alert ref="addAlert" :alerts="warnList" :item="warnItem"></add-alert>

		<report-news ref="reportNews"></report-news>
		<tool-tip-prop2 ref="toolTipProp2"></tool-tip-prop2>
		<closed-prop2 ref="closedProp2"></closed-prop2>
	</div>
</template>

<script>
import TimeOfPublic from '@/components/TimeOfPublic2.vue';
import FilterStatus from '@/components/filterStatus.vue';
import MeitiType2 from '@/components/MeitiType2.vue';
import ToolTipProp from '@/components/promptbox/ToolTipProp.vue';
import ConfirmProp from '@/components/promptbox/ConfirmProp.vue';
import ClosedProp from '@/components/promptbox/ClosedProp.vue';
import SuccessProp from '@/components/promptbox/SuccessProp.vue';
import ConfirmWarningProp from '@/components/promptbox/ConfirmWarningProp.vue';
import searchApi from '@/api/search';
import reportApi from '@/api/report';
import AddAlert from '@/views/components/global/AddAlert.vue';
import ReportNews from '@/views/components/monitoring/ReportNews.vue';
import { construct, destruct } from '@aximario/json-tree';

export default {
	components: {
		TimeOfPublic,
		FilterStatus,
		MeitiType2,
		ToolTipProp,
		ConfirmProp,
		SuccessProp,
		ClosedProp,
		ConfirmWarningProp,
		AddAlert,
		ReportNews
	},
	data() {
		return {
			warnList: [],
			warnItem: {},
			loading: false,
			keyWords2: '',
			meitiCheckList: ['1', '2', '3', '4', '8', '9', '10'],
			//查询对象
			query: {
				pageNo: 1, //页码
				pageSize: 50, //大小
				keyWordsType: 3, //内容or标题匹配
				keyWordsParserType: '0', //精准搜搜索
				keyWords: '', //搜索的关键字
				sort: 3, //排序
				property: '',
				sourceType: '1,2,3,4,8,9,10',
				days: '7',
				pageTimeStart: '',
				pageTimeEnd: '',
				tagLabels: '', // 分类标签 多个以英文,分割
				tagPlaces: '' // 地区标签 多个以英文,分割
			},
			query2: {},
			//数据对象
			pageData: {
				pageNo: 1,
				totalPages: 1,
				result: [],
				totalRows: 0
			},
			activePage: '1',
			tips: '',
			pipeiTypes: [
				{
					uuid: '3',
					name: '全部'
				},
				{
					uuid: '2',
					name: '标题'
				},
				{
					uuid: '1',
					name: '内容'
				}
			],
			paixus: [
				{
					uuid: '3',
					name: '时间降序'
				},
				{
					uuid: '4',
					name: '时间升序'
				}
			],
			shuxings: [
				{
					uuid: '',
					name: '全部'
				},
				{
					uuid: '1',
					name: '敏感'
				},
				{
					uuid: '0',
					name: '非敏感'
				}
			],
			total: 1,
			currentPage: 1,
			pageSize: 50,
			selectedListitem: {},
			fnStr: '',
			tags: [],
			tagValue: '',
			cityList: [],
			areaIds: [],
			selCity: {},
			defaultProps: {
				children: 'children',
				value: 'tagId',
				label: 'name',
				checkStrictly: true
			}
		};
	},
	created() {
		// this.getTags();
		// this.getCityList();
	},
	mounted() {},
	methods: {
		prePage() {
			if (this.query.pageNo > 1) {
				this.query.pageNo = this.query.pageNo - 1;
				this.search();
			}
		},
		nextPage() {
			if (this.query.pageNo < this.pageData.totalPages) {
				this.query.pageNo = this.query.pageNo + 1;
				this.search();
			}
		},
		//翻页
		handleCurrentChange(cur) {
			this.query.pageNo = cur;
			this.setQuery();
			this.search();
		},
		//复制
		copy(item, t) {
			let that = this;
			let text = '';
			if (t == 2) {
				text = item.url;
			} else {
				text = '标题：' + item.title + '\n链接：' + item.url + '\n时间：' + item.pageTime + '\n来源：' + item.websiteName;
			}

			this.$copyText(text).then(
				function(e) {
					that.$refs.closedProp2.show('内容已复制到剪切板！');
					// that.$message.success('内容已复制到剪切板！');
				},
				function(e) {
					that.$refs.closedProp2.show('抱歉，复制失败！');
					//that.$message.error('抱歉，复制失败！');
				}
			);
		},
		searchBtn() {
			this.query.keyWords = this.keyWords2;
			this.query.pageNo = 1;
			// console.log(this.query)
			this.query2 = JSON.parse(JSON.stringify(this.query));
			this.initPage();
		},
		initPage() {
			this.query.pageNo = 1;
			this.setQuery();
			this.query2 = JSON.parse(JSON.stringify(this.query));
			this.search();
		},
		//搜索并进入到第二页
		toTwoPage() {
			if (!this.keyWords2 || this.keyWords2.replace(/^\s+|\s+$/g, '') == '') {
				return;
			}
			this.query.keyWords = this.keyWords2.replace(/^\s+|\s+$/g, '');
			this.activePage = '2';
			this.query2 = JSON.parse(JSON.stringify(this.query));
			this.initPage();
		},
		//仅搜索
		search() {
			this.loading = true;
			this.query2.pageNo = this.query.pageNo;
			searchApi.getData(this.query2).then(res => {
				this.keyWords2 = this.query.keyWords;
				if (this.query2.sourceType) {
					this.meitiCheckList = this.query2.sourceType.split(',');
				}

				this.query = JSON.parse(JSON.stringify(this.query2));
				if (res.returnCode === '1001') {
					this.pageData = res.returnData;
					if (this.pageData.totalRows > 0) {
						this.pageData.result.forEach(item => {
							item.title = this.$utils.handleText(item.title);
							item.content = this.$utils.handleText(item.content);
							// this.$set(item, 'isShowZhaiyao', true);
							item.isShowZhaiyao = true;
							item.iszhankai = false;
						});
					}
					this.loading = false;
				}
			});
		},
		//监测时间 改变的
		changeTime(obj) {
			if (obj.days == '-1') {
				if (!obj.val) {
					this.query.pageTimeStart = '';
					this.query.pageTimeEnd = '';
				} else {
					if (obj.val[0]) {
						this.query.pageTimeStart = obj.val[0] + ' 00:00:00';
					}
					if (obj.val[1]) {
						this.query.pageTimeEnd = obj.val[1] + ' 23:59:59';
					}
				}
			} else {
				this.query.pageTimeStart = '';
				this.query.pageTimeEnd = '';
			}
			this.query.days = obj.days;
		},
		//匹配方式的值
		changepipeiTypes(obj) {
			this.query.keyWordsType = obj.type;
		},
		changepaixu(obj) {
			this.query.sort = obj.type;
		},
		changeMeitiType(obj) {
			this.query.sourceType = obj.join(',');
			this.meitiCheckList = obj;
		},
		//信息属性
		changeshuxing(obj) {
			this.query.property = obj.type;
		},
		//确认提示框 成功后的 函数
		confirmSucess(obj) {
			if (obj === 'ok') {
				eval(`this.${this.fnStr}()`);
			}
		},

		//显示确认提示框
		showConfirmProp(tips) {
			this.tips = tips;
			this.$refs.confirmProp.dialogVisible = true;
		},
		//显示确认提示框
		showConfirmProp2(tips) {
			//this.tips = tips
			this.$refs.confirmProp2.show(tips);
		},
		showReportLoading(tips) {
			this.$refs.reportLoading.show(tips);
		},
		//显示 自动关闭 提示框
		showClosedProp(tips) {
			this.tips = tips;
			this.$refs.closedProp.dialogVisible = true;
		},
		//数据加载中
		showLoadingProp() {
			this.$refs.loadingProp.dialogVisible = true;
		},
		closeLoadingProp() {
			this.$refs.loadingProp.dialogVisible = false;
		},
		//舆情上报
		singlepublicReport(item) {
			let _this = this;
			this.selectedListitem = item;
			reportApi.checkUrl({ url: item.url }).then(res => {
				if (res.returnCode == '100') {
					if (res.returnData.returnFlag == 1) {
						//判断是否达上限 等于1 就是达上限了
						_this.$my_confirm(res.returnData.returnFlagMsg, {
							yesBtnText: '确定',
							type: 'tips'
						});
						return false;
					}
					if (res.returnData.flag == 0) {
						_this.$refs.reportNews.initData(item);
						_this.$refs.reportNews.show();
					} else {
						_this.showToolTipProp2('该舆情已报送，请不要重复上报!');
					}
				} else {
					_this.showToolTipProp2(res.returnMsg);
				}
			});
		},
		singlepublicReportClose() {
			let _this = this;
			// _this.showToolTipProp2('报送成功!');
			this.$my_confirm('报送成功!', {
				yesBtnText: '确定',
				type: 'success'
			})
				.then(() => {
					//点登录
				})
				.catch(() => {
					//点取消
				});
		},
		showToolTipProp2(tips) {
			this.$refs.toolTipProp2.show(tips);
		},
		//单个加入预警
		singleEarly(item, forceFlag) {
			this.$my_confirm('确定要加入预警?', {
				isShowCancelBtn: true,
				type: 'question'
			})
				.then(() => {
					searchApi
						.addWarning({
							id: item.id,
							type: 1,
							forceFlag: forceFlag
						})
						.then(res => {
							if (res.returnCode === '1001' || res.returnCode == '4001') {
								if (res.returnMsg) {
									this.showClosedProp(res.returnMsg);
								} else {
									this.showClosedProp('加入预警成功');
								}
							} else if (res.returnCode == '4002') {
								//相似数据呈现
								this.warnList = res.returnData;
								this.warnItem = item;
								this.$refs.addAlert.show();
							} else {
								this.showClosedProp(res.returnMsg);
							}
						});
					//点登录
				})
				.catch(() => {
					//点取消
				});
		},
		//一级页 选择标签
		selectedTag(item) {
			this.tagValue = item.tagId;
			this.query.keyWords = this.query.keyWords.replace(/^\s+|\s+$/g, '');
			this.activePage = '2';
			this.initPage();
		},
		handleChangeCity(value) {
			this.areaIds = value;
			this.selCity = this.$refs['cascaderCity'].getCheckedNodes()[0];
		},
		/*获取涉世地区*/
		async getCityList() {
			let _this = this;
			let datas = await searchApi.getTags({ id: 2 });

			if (datas.returnCode !== '1001') return false;
			let result = construct(datas.returnData, {
				id: 'tagId',
				pid: 'parentId',
				name: 'name',
				children: 'children'
			});
			_this.cityList = result;
		},
		async getTags() {
			let datas = await searchApi.getTags({ id: 1 });

			// returnCode: "1001"
			// returnData: [{children: Array(11)
			// description: "涉及生活环境自然环境以及自然生态环保相关的社会舆情"
			// name: "生态环境"
			// number: 0
			// parentId: 2
			// tagId: 10069}]
			// returnMsg: "操作成功
			if (datas.returnCode !== '1001') return false;
			this.tags = datas.returnData;
		},
		setQuery() {
			//1.标签 及 其子标签 用逗号连接
			let taglist = this.tags.filter(item => {
				return item.tagId === this.tagValue;
			});
			let tagNames = [];
			if (taglist.length > 0) {
				if (taglist[0].children && taglist[0].children.length > 0) {
					tagNames = taglist[0].children.map(item => {
						return item.name;
					});
				}
				tagNames.unshift(taglist[0].name);
			}

			this.query.tagLabels = tagNames.join(',');
			// tagLabels
			// tagPlaces
			// children: Array(14)
			// name: "湖南省"
			// number: 1
			// parentId: 5
			// tagId: 1218
			//2.选中的 地域 名称 用逗号连接
			let cityNs = [];
			if (this.selCity) {
				cityNs.push(this.selCity.label);
				if (this.selCity.children && this.selCity.children.length > 0) {
					this.filterCity(cityNs, this.selCity.children);
				}
			}
			this.query.tagPlaces = cityNs.join(',');
		}, //
		filterCity(cityNs, arr) {
			for (let i = 0; i < arr.length; i++) {
				cityNs.push(arr[i].label);
				if (arr[i].children.length > 0) {
					this.filterCity(cityNs, arr[i].children);
				}
			}
			return cityNs;
		}
		// filterCity(cityNs, citys,areaIds) {
		// 	let filterCitys = citys.filter(item => {
		// 		return areaIds.indexOf(item.tagId) !== -1;
		// 	});
		// 	if(filterCitys.length > 0){
		// 		cityNs.push(filterCitys[0].name)
		// 		if(filterCitys[0].children && filterCitys[0].children.length > 0){
		// 			this.filterCity(cityNs,filterCitys[0].children,areaIds)
		// 		}
		// 	}
		// 	return cityNs
		// }
	},
	watch: {
		activePage: {
			handler: function(val, oldval) {
				if (val === '2') {
					// this.showLoadingProp();
					// setTimeout(() => {
					// 	this.closeLoadingProp();
					// }, 2000);
				}
			},
			deep: true //对象内部的属性监听，也叫深度监听
		}
	}
};
</script>

<style lang="less">
@import '~@/assets/css/page/search/search.less';
</style>
